<template>
  <v-layout justify-end>
    <v-btn color="blue-grey" class="white--text" :loading="loading" @click="onGenerate">
      Generate
      <v-icon right dark>mdi-cloud-upload</v-icon>
    </v-btn>
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <p>Generating: {{item.name}}</p>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {
  GENERATE_DOC_MUTATION,
  TASK_STATUS_QUERY
} from "../../../constants/graphql";
import { setTimeout } from "timers";
import EventBus from "../../../store/event-bus";
export default {
  name: "AvailableDocumentsListActions",
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      loading: false,
      taskId: null,
      generateDocumentStatus: {},
      checkStatus: false
    };
  },
  methods: {
    onGenerate() {
      //this.loading = true;
      //console.log('generating for: ',this.item);
      this.$apollo
        .mutate({
          mutation: GENERATE_DOC_MUTATION,
          variables: {
            itineraryId: this.item.itineraryId,
            documentTypeId: this.item.id
          }
        })
        .then(this.generateDocHandler, this.generateDocErrHandler);
    },
    generateDocErrHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error"
      });
      this.emit("error", err.graphQLErrors[0].message);
    },
    generateDocHandler(result) {
      this.loading = true;
      this.taskId = result.data.generateDocument.id;
      this.checkStatus = true;
    }
  },
  apollo: {
    taskStatus: {
      query: TASK_STATUS_QUERY,
      variables: function() {
        return { taskId: this.taskId };
      },
      result({ data, loader, networkStatus }) {
        this.checkStatus = false;
        if (data.taskStatus.status == "IN_PROGRESS") {
          setTimeout(() => {
            this.checkStatus = true;
          }, 2000);
        } else {
          this.loading = false;
          this.$store.dispatch("showAppSnackbar", {
            msg: `Document "${this.item.name}" is ready`
          });
          EventBus.$emit("documentGenerated", this.item);
        }
        //console.log('status',data.generateDocumentStatus.status);
      },
      skip() {
        return !this.checkStatus;
      },
      fetchPolicy: "network-only"
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/AvailableDocumentsListActions.vue